import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-short",
  "use": "icon-arrow--cta-short-usage",
  "viewBox": "0 0 18 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 11\" id=\"icon-arrow--cta-short\"><path d=\"M12.181 1a.528.528 0 0 0-.475.357.544.544 0 0 0 .143.58l3.25 3.02H1.56a.548.548 0 0 0-.56.567.547.547 0 0 0 .56.51c.279-.015 13.538 0 13.538 0l-3.25 3.014a.538.538 0 0 0-.161.593.541.541 0 0 0 .284.312.527.527 0 0 0 .598-.114l4.26-3.95a.54.54 0 0 0 0-.792l-4.26-3.95A.531.531 0 0 0 12.18 1Z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol